import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, {AxiosError} from "axios";

import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";


import {ApiGroupsLessonsResponse} from "features/model/types/groups/groupsLessonsSchema";
import {setGroupsLessons} from "../../../slice/groups/set-groups-lessons/setGroupsLessonsSlice";
import {createRequestParams} from "common/hook/create-request-params/createRequestParams";
import {Navigate, useNavigate} from "react-router-dom";
import {setNotFoundError} from "features/model/slice/error/errorSlice";



interface FetchLessonsParams {
    groupId: string | undefined | null;
    from?: string;
    to?: string;
    page?: number;
}


export const fetchLessonsByGroupsId = createAsyncThunk(
    "groups/fetchLessonsByGroupsId",
    async ({ groupId, from, to, page }: FetchLessonsParams, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);

            const params = createRequestParams(from, to, page);

            const response = await axios.get<ApiGroupsLessonsResponse>(
                `/api/groups/${groupId}/lessons`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params,
                }
            );

            if (response.data && response.data.success) {
                thunkAPI.dispatch(setGroupsLessons(response.data.data));
            }
            return response.data;
        } catch (error) {
            thunkAPI.dispatch(setNotFoundError((error as AxiosError).response!.status));
        }
    }
);
